var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#projectContainer{position:fixed;top:57px;color:maroon;background:url(" + escape(require("../../assets/fondHead.png")) + ");padding-bottom:5px;padding-right:10px;padding-left:10px;width:100%;z-index:100000}#projectContainerText{text-align:left;padding:5px}#accueilTitle,.container-fluid>h1,h4{padding-top:20px;text-align:left}#versionAlert{text-align:left}#homeText{margin-top:200px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-58ebb511","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/layout/Home.vue
// module id = 671
// module chunks = 0